import React, { FC } from 'react';
import { withSuffix } from 'src/common/utils/dataAttributeHelpers';
import pictograms from './pictograms.svg';

const CDN_DOMAIN = process.env.NEXT_PUBLIC_ASSETS_CDN;

const imageMap = {
  new: pictograms.replace(CDN_DOMAIN, ''),
};

export const sizes = {
  m: 20,
  l: 24,
  xl: 32,
  xxl: 48,
} as const;

export type Sizes = keyof typeof sizes;

// Add your pictogram IDs here as you create them
export const pictogramIds = [
  'looks-good',
  'high-demand',
  'in-demand',
  'limited-availability',
  'unavailable',
  'rare-discovery',
  'instant-booking',
  'static-map-pin-blue',
  'static-map-pin-green',
] as const;

export type PictogramIds = (typeof pictogramIds)[number];

export type IconPictogramProps = {
  id: PictogramIds;
  className?: string;
  /**
   * Descriptive text that can be used by screen readers
   */
  alt?: string;
  size?: Sizes;
  'data-test'?: string;
};

/**
 * IconPictogram is used for multi-color icons that maintain their specific colors.
 * Unlike IconDS22, these icons do not inherit color from parent elements.
 */
const IconPictogram: FC<IconPictogramProps> = ({
  id,
  className,
  size = 'xl',
  alt,
  'data-test': dataTest,
}) => {
  const widthHeight = sizes[size];

  return (
    <svg
      className={className}
      width={widthHeight}
      height={widthHeight}
      viewBox="0 0 32 32"
      data-test={withSuffix(dataTest, 'pictogram')}
    >
      {alt && <title>{alt}</title>}
      <use
        xlinkHref={`${imageMap.new}#${id}`}
        aria-hidden="true"
      />
    </svg>
  );
};

export default IconPictogram;
